import { render, staticRenderFns } from "./InvoiceSummary.vue?vue&type=template&id=056964e6&scoped=true&"
import script from "./InvoiceSummary.vue?vue&type=script&lang=ts&"
export * from "./InvoiceSummary.vue?vue&type=script&lang=ts&"
import style0 from "./InvoiceSummary.vue?vue&type=style&index=0&id=056964e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056964e6",
  null
  
)

export default component.exports